'use strict';

var AppState = require('app_state');
var ThemeUtils = require('utils/theme/utils');

// Extracted and adapted from 'jquery.app.js' (Ubold Admin Template 1.5)

var Sidemenu = {};

Sidemenu.openLeftBar = function () {
    AppState.menuIsExpanded = !AppState.menuIsExpanded;

    // close search bar if open
    if ($('#mobile-search-bar').is(':visible')) {
        $('#app').find('#mobile-search-bar').removeClass('in');
    }

    $('#wrapper').toggleClass('enlarged');
    $('#wrapper').addClass('forced');

    if ($('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left')) {
        $('body').removeClass('fixed-left').addClass('fixed-left-void');
    } else if (!$('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left-void')) {
        $('body').removeClass('fixed-left-void').addClass('fixed-left');
    }

    if ($('#wrapper').hasClass('enlarged')) {
        $('.left ul').removeAttr('style');
    } else {
        $('.subdrop').siblings('ul:first').show();
    }

    ThemeUtils.toggle_slimscroll('.slimscrollleft');
    $('body').trigger('resize');
};

Sidemenu.menuItemClick = function (e) {
    if (!$('#wrapper').hasClass('enlarged')) {
        if (!$(this).hasClass('subdrop')) {
            // hide any open menus and remove all other classes
            $('ul', $(this).parents('ul:first')).slideUp(350);
            $('a', $(this).parents('ul:first')).removeClass('subdrop');
            $('#sidebar-menu .pull-right i').removeClass('md-remove').addClass('md-add');

            // open our new menu and add the open class
            $(this).next('ul').slideDown(350);
            $(this).addClass('subdrop');
            $('.pull-right i', $(this).parents('.has_sub:last')).removeClass('md-add').addClass('md-remove');
            $('.pull-right i', $(this).siblings('ul')).removeClass('md-remove').addClass('md-add');
        } else if ($(this).hasClass('subdrop')) {
            $(this).removeClass('subdrop');
            $(this).next('ul').slideUp(350);
            $('.pull-right i', $(this).parent()).removeClass('md-remove').addClass('md-add');
        }
    }
};

Sidemenu.init = function () {
    var $this = this;

    this.$menuItem = $('#sidebar-menu a');

    var ua = navigator.userAgent,
        event = ua.match(/iP/i) ? 'touchstart' : 'click';

    // LEFT SIDE MAIN NAVIGATION
    $this.$menuItem.on(event, $this.menuItemClick);

    // NAVIGATION HIGHLIGHT & OPEN PARENT
    $('#sidebar-menu ul li.has_sub a.active')
        .parents('li:last')
        .children('a:first')
        .addClass('active')
        .trigger('click');
};

Sidemenu.initToggle = function () {
    var $this = this;

    this.$openLeftBtn = $('.open-left');

    var ua = navigator.userAgent;
    var event = ua.match(/iP/i) ? 'touchstart' : 'click';

    //bind on click
    this.$openLeftBtn.on(event, function (e) {
        e.stopPropagation();
        e.preventDefault();
        $this.openLeftBar();
    });
};

var doCloseMobileMenu = function (delay) {
    setTimeout(function () {
        AppState.menuIsExpanded = !AppState.menuIsExpanded;
        $('#app').find('#wrapper').toggleClass('enlarged'); // close sidemenu area
        $('#app').find('#sidebar-menu-toggle').toggleClass('enlarged'); // expand tab at bottom
    }, delay);
};

Sidemenu.closeMobileMenu = function (e) {
    if ($(window).width() < 768 && !$('#wrapper').hasClass('enlarged')) {
        // mobile menu open (not enlarged) & clicked somewhere
        if (!$(e.target).closest('#sidebar-menu').length) {
            // clicked outside the menu
            doCloseMobileMenu(0);
        } else {
            // clicked on menu
            if ($(e.target).closest('li').find('li').length <= 1) {
                // menu item has no subitems, add some delay (at least 600 for the iPhone)
                // before closing to wait for other events
                doCloseMobileMenu(600);
            }
        }
    }
};

module.exports = Sidemenu;
